module.exports = __webpack_public_path__ + "img/local-10.7748f840.jpg";